/**
 * @generated SignedSource<<4f554ac98857eccf8fcbbd43e9e93dd1>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "_id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "careOrderIdList"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "_id",
                    "variableName": "_id"
                },
                {
                    "kind": "Variable",
                    "name": "careOrderIdList",
                    "variableName": "careOrderIdList"
                }
            ],
            "concreteType": "ClientCareOrder",
            "kind": "LinkedField",
            "name": "clientCareOrderList",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feedback",
                    "kind": "LinkedField",
                    "name": "feedback",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isScored",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "graphqlClientCareOrderForFeedbackQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "graphqlClientCareOrderForFeedbackQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "f9db8305b7ad5a0356a8013540ffc84f",
            "id": null,
            "metadata": {},
            "name": "graphqlClientCareOrderForFeedbackQuery",
            "operationKind": "query",
            "text": "query graphqlClientCareOrderForFeedbackQuery(\n  $_id: String!\n  $careOrderIdList: [String]\n) {\n  clientCareOrderList(_id: $_id, careOrderIdList: $careOrderIdList) {\n    _id\n    feedback {\n      isScored\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "7ad6341f3add7db3202390c9d71ff530";
export default node;
